export default {
  rationsData: (state) => {
    return state.rations || []
  }
}
